export default function () {
    document.addEventListener("change", function(e) {
        console.log(e)
        if (e.target.matches(".distributor-list-filter select")) {
            const select = e.target;
            const parent = select.closest(".distributor-list");
            if (!parent) return;

            applyDistributorFilter(parent);
        }
    });

    function applyDistributorFilter(parent) {
        if (!parent) return;
        const country = parent.querySelector("select").value ?? "";

        const items = parent.querySelectorAll(".distributor");

        items.forEach(item => {
            let show = true;

            const countries = item.getAttribute("data-filter-countries")?.split("|").map(tag => tag.toLowerCase()) ?? [];
            if (country.length > 0 && (countries.length == 0 || !countries.includes(country.toLowerCase()))) show = false;

            if (show) {
                item.style.display = "flex";
            } else {
                item.style.display = "none";
            }
        });        
    }
}